/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint func-names: ["error", "never"] */

import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import datetime from '../helpers/datetime';

import {
  app,
} from '../main';
import * as types from './mutation-types';

export const state = {
  lang: 'en',
  loading: false,
  _id: 0,
  habbits: [],
};

export const mutations = {
  add(state, name) {
    console.log('mutations.add', name);
    const today = datetime.getTodaysDate();
    state.habbits.push({
      id: state._id,
      name,
      startedOn: today,
      lastDone: '1970-01-01',
      done: 0,
      dones: {},
    });
    state._id += 1;
  },
  tick(state, id) {
    console.log('mutations.tick', id);
    const index = _.findIndex(state.habbits, val => val.id === id);
    const today = datetime.getTodaysDate();
    const found = state.habbits[index];
    Vue.set(state.habbits, index, Object.assign(found, {
      lastDone: today,
      lastDoneTS: Date.now(),
      dones: Object.assign({
      }, found.dones, {
        [today]: true,
      }),
      done: found.done + 1,
    }));
  },

  untick(state, id) {
    console.log('mutations.untick', id);
    const index = _.findIndex(state.habbits, val => val.id === id);
    const today = datetime.getTodaysDate();
    const found = state.habbits[index];
    const newDones = Object.assign({}, found.dones, {
      [today]: false,
    });
    const allDays = Object.keys(newDones).filter(k => newDones[k]);
    const lastDone = allDays.sort().reverse()[0] || '1970-01-01';
    Vue.set(state.habbits, index, Object.assign(found, {
      lastDone,
      lastDoneTS: moment(lastDone).valueOf(),
      dones: newDones,
      done: found.done - 1,
    }));
  },

  remove(state, id) {
    console.log('mutations.remove', id);
    state.habbits = state.habbits.filter(val => val.id !== id);
  },
};

export const actions = {
  setLang({
    commit,
  }, payload) {
    commit(types.SET_LANG, payload);
  },
  async setLangNew({
    commit,
  }, payload) {
    if (payload in app.$i18n.messages) {
      commit(types.SET_LANG, payload);
    } else {
      try {
        const res = await import(`../lang/locale/${payload}.json`);
        app.$i18n.setLocaleMessage(payload, res.data);
        commit(types.SET_LANG, payload);
      } catch (e) {
        console.log(e);
      }
    }
  },
};
